module.exports = __webpack_public_path__ + "img/logout-icon.789eb0bc.svg";